import { Request } from './http';
import { OSInfoLog } from './type';

export const Auth = {
  async feishuLogin(data: { code: string; redirect_uri: string }) {
    return await Request({
      api: '/auth/login',
      method: 'POST',
      data,
    });
  },
  async check() {
    const resp: {
      user_id: string;
      user_name: string;
    } = await Request({
      api: '/auth/check',
      method: 'POST',
    });

    return resp;
  },
};

export const Credit = {
  fetchList: (query: any) => {
    return Request({
      api: '/api/user/credit_list',
      method: 'POST',
      data: query,
    });
  },
  update: (query: any) => {
    const q = new URLSearchParams();

    q.set('userId', query.user_id);
    q.set('creditScore', query.score);
    q.set('reason', query.reason);
    q.set('remark', query.remark);

    return Request({
      api: '/api/proxy_platform',
      method: 'POST',
      data: {
        method: 'POST',
        url: '/apis/platform/userDeviceBan/banByCreditScore?' + q.toString(),
        data: '',
      },
    });
  },
  updateEx: (query: { user_id: string; score: number; reason: string; remark: string }) => {
    return Request({
      api: '/api/user/credit_update',
      method: 'POST',
      data: query,
    });
  },
  current: async (userId: string) => {
    const res = await Request<any, number>({
      api: '/api/proxy_platform',
      method: 'POST',
      data: {
        method: 'GET',
        url: `/apis/risk/score/${userId}`,
        data: '',
      },
    });

    return res;
  },
  /**
   * 后台查到的操作历史
   */
  actionList(query: any) {
    const q = new URLSearchParams();

    q.set('userId', query.user_id);
    q.set('current', '1');
    q.set('size', '10');

    return Request({
      api: '/api/proxy_platform',
      method: 'POST',
      data: {
        method: 'GET',
        url: '/apis/platform/userDeviceBan/operationLogs?' + q.toString(),
        data: '',
      },
    });
  },
  /**
   * 用户登录时会看到的信息
   */
  tips(userId: string) {
    const q = new URLSearchParams();

    q.set('userId', userId);

    return Request({
      api: '/api/proxy_platform',
      method: 'POST',
      data: {
        method: 'GET',
        url: '/apis/platform/userDeviceBan/userDevices?' + q.toString(),
        data: '',
      },
    });
  },
  unbanTime(query: any) {
    // /platform/userDeviceBan/unbanByTime

    const q = new URLSearchParams();

    q.set('userId', query.userId);
    q.set('reason', query.reason);
    q.set('remark', query.remark);

    return Request({
      api: '/api/proxy_platform',
      method: 'POST',
      data: {
        method: 'POST',
        url: '/apis/platform/userDeviceBan/unbanByTime?' + q.toString(),
        data: '',
      },
    });
  },
  banTime(query: any) {
    const q = new URLSearchParams();
    q.set('userId', query.userId);
    q.set('banEnd', query.banEnd);
    q.set('reason', query.reason);
    q.set('remark', query.remark);

    return Request({
      api: '/api/proxy_platform',
      method: 'POST',
      data: {
        method: 'POST',
        url: '/apis/platform/userDeviceBan/banByTime?' + q.toString(),
        data: '',
      },
    });
  },
};

export interface SensitiveRiskUserRecord {
  id: number;
  user_id: string;
  risk_type: string;
  risk_level: number | null;
  hit_count: number | null;
  last_hit_content: string | null;
  last_hit_words: string | null;
  last_hit_label: number | null;
  last_hit_time: string | null;
  mute_until: string | null;
  mute_reason: string | null;
  status: number | null;
  handle_status: number | null;
  handle_remark: string | null;
  handle_time: string | null;
  handle_by: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface SensitiveRiskUserQueryResp {
  records: SensitiveRiskUserRecord[];
  has_mute: boolean;
}

export interface SensitiveRiskUserUnmuteResp {
  db_rows_affected: number;
  redis_deleted: number;
}

export const User = {
  async info(userId: string, userNick: string) {
    const res = await Request({
      api: '/api/user/info',
      method: 'POST',
      data: {
        user_id: userId,
        user_nick: userNick,
      },
    });
    return res.data;
  },
  async infoEx(query: any) {
    const res = await Request({
      api: '/api/user/info_ex',
      method: 'POST',
      data: query,
    });
    return res.data;
  },
  async infoList(userIdList: string[]): Promise<
    {
      DisableRemark: string;
      NickName: string;
      Status: number;
      UserId: string;
      UserRegtime: string;
    }[]
  > {
    const res = await Request({
      api: '/api/user/info_list',
      method: 'POST',
      data: {
        user_id_list: userIdList,
      },
    });
    return res.data;
  },
  async infoMixList(userIdList: string[]): Promise<
    {
      DisableRemark: string;
      NickName: string;
      Status: number;
      UserId: string;
      UserRegtime: string;

      report_count: Record<string, number>;

      game_stat: {
        day: string;
        user_id: string;
        md_cnt: number;
        dota_cnt: number;
        omg_cnt: number;
        rpg_cnt: number;
        other_cnt: number;
        total_cnt: number;
      };
    }[]
  > {
    const res = await Request({
      api: '/api/user/info_mix_list',
      method: 'POST',
      data: {
        user_id_list: userIdList,
      },
    });
    return res.data;
  },
  async banList(userIdList: string[], mark: string, dayOffset: number, exData: Record<string, any>) {
    const res = await Request({
      api: '/api/user/ban_list',
      method: 'POST',
      data: {
        user_id_list: userIdList,
        mark: mark,
        day_offset: dayOffset,
        ex_data: exData,
      },
    });
    return res.data;
  },
  async unbanList(userIdList: string[], mark: string) {
    const res = await Request({
      api: '/api/user/unban_list',
      method: 'POST',
      data: {
        user_id_list: userIdList,
        mark: mark,
      },
    });
    return res.data;
  },
  ladderLimitGet(userId: string) {
    return Request({
      api: '/api/user/ladder_limit',
      method: 'GET',
      data: {
        user_id: userId,
      },
    });
  },
  ladderLimitClear(userId: string) {
    return Request({
      api: '/api/user/ladder_limit/clear',
      method: 'POST',
      data: {
        user_id: userId,
      },
    });
  },
  async reportCountList(userIdList: string[]) {
    const res = await Request({
      api: '/api/user/report_count_list',
      method: 'POST',
      data: {
        user_id_list: userIdList,
      },
    });

    return res.data;
  },
  async OSInfoLog(userId: string) {
    const res = await Request({
      api: '/api/user/os_info_log',
      method: 'POST',
      data: {
        user_id: userId,
      },
    });

    return res.data as OSInfoLog[];
  },
  async OSInfoLogByUUID(uuid: string) {
    const res = await Request({
      api: '/api/user/list_by_hardware_uuid?uuid=' + uuid,
      method: 'POST',
      data: {},
    });

    return res.data as OSInfoLog[];
  },
  async sensitiveRiskGet(userId: string): Promise<SensitiveRiskUserQueryResp> {
    const res = await Request<{ user_id: string }, { data: SensitiveRiskUserQueryResp }>({
      api: '/api/user/sensitive_risk',
      method: 'GET',
      data: {
        user_id: userId,
      },
    });

    return res.data;
  },
  async sensitiveRiskUnmute(userId: string): Promise<SensitiveRiskUserUnmuteResp> {
    const res = await Request<{ user_id: string }, { data: SensitiveRiskUserUnmuteResp }>({
      api: '/api/user/sensitive_risk/unmute',
      method: 'POST',
      data: {
        user_id: userId,
      },
    });

    return res.data;
  },
};

export interface PDItem {
  AccessRights: string;
  Date: string;
  DesiredAccess: number;
  ID: number;
  ProcessData: string;
  UserId: string;
}

export interface MatchedProcessLog {
  log_id: number;
  date: string;
  desired_access: number;
  access_rights_raw: string;
  access_rights: string[];
  process_data_raw: string;
  titles_raw: string;
  titles: string[];
  path: string;
  pname: string;
  pid: number;
}

export interface CategoryMatch {
  key: string;
  name: string;
  source_sql: string;
  matched_log_ids: number[];
  matched_logs: MatchedProcessLog[];
}

export interface SkippedLog {
  log_id: number;
  date: string;
  process_data_raw: string;
  reason: string;
}

export interface DetectionReport {
  user_id: string;
  start: string;
  end: string;
  fetched_log_count: number;
  categories: CategoryMatch[];
  skipped_logs: SkippedLog[];
}

export interface SuspiciousUserInfo {
  UserId: string;
  NickName: string;
  Status: number;
  DisableRemark: string;
  UserRegtime: string;
}

export interface SuspiciousBanDeviceInfo {
  uuid_hardware: string[];
  uuid_os: string[];
  ban_type: string;
}

export interface SuspiciousBanLog {
  id: number;
  user_id: string;
  date: string;
  user_nick: string;
  ban_reason: string;
  device_info: string;
  ban_type: string;
  parsed_device_info?: SuspiciousBanDeviceInfo;
}

export interface SuspiciousGameStat {
  day: string;
  user_id: string;
  md_cnt: number;
  dota_cnt: number;
  omg_cnt: number;
  rpg_cnt: number;
  other_cnt: number;
  total_cnt: number;
}

export interface SuspiciousMonthStat {
  month: string;
  start: string;
  end: string;
  game_stat: SuspiciousGameStat;
  cheating_report_uv: number;
  report_per_game: number;
}

export interface SuspiciousReplayReportMonthStat {
  month: string;
  total_count: number;
  problem_count: number;
}

export interface AdminOperatorLog {
  id: number;
  admin_id: string;
  admin_name: string;
  type: string;
  date: string;
  data: string;
}

export interface SuspiciousInfoResponse {
  user: SuspiciousUserInfo;
  is_banned: boolean;
  ban_log: SuspiciousBanLog | null;
  warning?: string;
  month_stats: SuspiciousMonthStat[];
  replay_report_month_stats: SuspiciousReplayReportMonthStat[];
  process_report: DetectionReport;
  operator_logs: AdminOperatorLog[];
}

export const Cheat = {
  async processData(userId: string): Promise<DetectionReport> {
    const res = await Request<{ user_id: string }, { data: DetectionReport }>({
      api: '/api/cheat/process_data',
      method: 'POST',
      data: {
        user_id: userId,
      },
    });
    return res.data;
  },
  async suspiciousInfo(userId: string): Promise<SuspiciousInfoResponse> {
    const res = await Request<{ user_id: string }, { data: SuspiciousInfoResponse }>({
      api: '/api/cheat/suspicious_info',
      method: 'POST',
      data: {
        user_id: userId,
      },
    });
    return res.data;
  },
  async userTeammateCount(userId: string, dayCount: 7 | 30): Promise<Record<string, number>> {
    const res = await Request<{ user_id: string; day_count: 7 | 30 }, { data: Record<string, number> }>({
      api: '/api/cheat/user_teammate_count',
      method: 'POST',
      data: {
        user_id: userId,
        day_count: dayCount,
      },
    });
    return res.data || {};
  },
};

export interface ReplayCollectGame {
  id: number;
  user_id: string;
  game_id: string;
  remark: string;
  updated_at: string;
  created_at: string;
  game_name: string;
  start_time: string;
  room_type: string;
  match_type: string;
}

export const ReplayCollect = {
  async list(userId: string): Promise<ReplayCollectGame[]> {
    const res = await Request<{ user_id: string }, { data: ReplayCollectGame[] }>({
      api: '/api/replay/collect/list',
      method: 'GET',
      data: {
        user_id: userId,
      },
    });
    return res.data || [];
  },
  async create(query: { user_id: string; game_id: string; remark?: string }): Promise<ReplayCollectGame> {
    const res = await Request<{ user_id: string; game_id: string; remark?: string }, { data: ReplayCollectGame }>({
      api: '/api/replay/collect/create',
      method: 'POST',
      data: query,
    });
    return res.data;
  },
};

export interface ReplayGameNameLookupResult {
  game_id: string;
  game_name: string;
  source: string;
  start_time: string;
}

export const ReplayGameNameLookup = {
  async query(query: { game_name: string; month: string }): Promise<ReplayGameNameLookupResult | null> {
    const res = await Request<{ game_name: string; month: string }, { data: ReplayGameNameLookupResult | null }>({
      api: '/api/replay/game_name_to_id',
      method: 'GET',
      data: query,
    });
    return res.data || null;
  },
};

export interface AutoBanLog {
  data: string;
  date: string;
  id: number;
  type: string;
  user_id: string;
}

export interface AutoBanLogQuery {
  start?: string;
  end?: string;
  page?: number;
  page_size?: number;
  type?: string;
  types?: string[];
  user_id?: string;
}

export const Scheduler = {
  async configGet() {
    const res = await Request({
      api: '/api/scheduler/config_get',
      method: 'GET',
    });
    return res.data;
  },
  async configSet(query: any) {
    const res = await Request({
      api: '/api/scheduler/config_set',
      method: 'POST',
      data: query,
    });
    return res.data;
  },
  async autoBanLog(query: AutoBanLogQuery): Promise<AutoBanLog[]> {
    const res = await Request<AutoBanLogQuery, { data: AutoBanLog[] }>({
      api: '/api/scheduler/auto_ban_log',
      method: 'POST',
      data: query,
    });
    return res.data;
  },
  async processDataList(ids: number[]): Promise<PDItem[]> {
    const res = await Request({
      api: '/api/scheduler/process_data_list',
      method: 'POST',
      data: {
        ids,
      },
    });
    return res.data;
  },
};

export interface ConfigItem {
  config: string;
  key: string;
  name: string;
  rule: string;
  status: number;
}

export const Config = {
  async getConfig(key: string) {
    const res = await Request({
      api: '/api/config/get',
      method: 'GET',
      data: {
        key: key,
      },
    });
    return res.data;
  },
};

export interface OssTokenResp {
  policy: string;
  security_token: string;
  x_oss_signature_version: string;
  x_oss_credential: string;
  x_oss_date: string;
  signature: string;
  host: string;
  object_key: string;
}

export const Mpq = {
  async versionList() {
    const res = await Request({
      api: '/api/mpq/version_list',
      method: 'GET',
    });
    return res.data;
  },
  async ossToken(query: { key: string; version: number; expire_seconds?: number }): Promise<OssTokenResp> {
    const res = await Request({
      api: '/api/mpq/oss_token',
      method: 'POST',
      data: query,
    });
    return res.data;
  },
  async versionCreate(query: { key: string; status?: number }) {
    const res = await Request({
      api: '/api/mpq/version_create',
      method: 'POST',
      data: query,
    });
    return res.data;
  },
  async versionStatus(query: { id: number; status: number }) {
    return Request({
      api: '/api/mpq/version_status',
      method: 'POST',
      data: query,
    });
  },
  async uploadConfirm(query: { id: number; md5: string }) {
    return Request({
      api: '/api/mpq/upload_confirm',
      method: 'POST',
      data: query,
    });
  },
};

export interface UpdateManifestModule {
  key: string;
  version: string;
  url: string;
  sha1: string;
}

export interface UpdateManifest {
  quick_version: number;
  build_number: number;
  install_sha1: string;
  install_url: string;
  modules: UpdateManifestModule[];
}

export type UpdateReleaseStatus = 'draft' | 'enabled' | 'baseline' | 'archived';
export type UpdateModuleStatus = 'disabled' | 'enabled';
export type UpdateRolloutStatus = 'draft' | 'gray' | 'official' | 'archived';

export interface UpdateReleaseRecord {
  id: number;
  name: string;
  quick_version: number;
  build_number: number;
  manifest_sha256: string;
  status: UpdateReleaseStatus;
  remark: string;
  update_description: string;
  created_by: string;
  created_by_name: string;
  updated_by: string;
  updated_by_name: string;
  created_at: string;
  updated_at: string;
}

export interface UpdateRolloutBrief {
  id: number;
  download_percent: number;
  use_percent: number;
  status: UpdateRolloutStatus;
  remark: string;
  created_at: string;
  updated_at: string;
}

export interface UpdateModuleVersionRecord {
  id: number;
  release_id: number;
  release_name: string;
  release_status: UpdateReleaseStatus;
  module_key: string;
  module_version: string;
  version_key: string;
  build_number: number;
  url: string;
  download_url: string;
  sha1: string;
  status: UpdateModuleStatus;
  created_at: string;
  updated_at: string;
}

export interface UpdateRolloutRecord extends UpdateRolloutBrief {
  module_key: string;
  module_version_id: number;
  created_by: string;
  created_by_name: string;
  updated_by: string;
  updated_by_name: string;
  release_id?: number;
  release_name?: string;
  release_status?: UpdateReleaseStatus;
  module_version?: string;
  version_key?: string;
  build_number?: number;
  url?: string;
  download_url?: string;
  sha1?: string;
}

export interface UpdateCheckJSONPublishResult {
  triggered: boolean;
  bucket: string;
  key: string;
  url: string;
  error?: string;
}

export interface UpdatePageResp<T> {
  records: T[];
  total: number;
  current: number;
  size: number;
}

export interface UpdateReleaseUploadResp {
  release: UpdateReleaseRecord;
  modules: UpdateModuleVersionRecord[];
  duplicate?: boolean;
}

export interface UpdateReleaseDetailResp {
  release: UpdateReleaseRecord;
  modules: UpdateModuleVersionRecord[];
  manifest: UpdateManifest;
}

export interface UpdateRolloutUpsertResp {
  rollout: UpdateRolloutRecord;
  check_json_publish?: UpdateCheckJSONPublishResult;
}

export interface UpdateReleaseStatusResp {
  release: UpdateReleaseRecord;
  archived_baseline_release_ids: number[];
  created_rollout_ids: number[];
  created_rollout_count: number;
  check_json_publish?: UpdateCheckJSONPublishResult;
}

export interface UpdateReleaseUpdateResp {
  release: UpdateReleaseRecord;
  check_json_publish?: UpdateCheckJSONPublishResult;
}

function cleanUpdateQuery<T extends Record<string, unknown>>(query: T) {
  return Object.fromEntries(
    Object.entries(query).filter(([, value]) => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== undefined && value !== null && value !== '';
    }),
  );
}

export const UpdateRelease = {
  async upload(query: { name: string; manifest: UpdateManifest; remark?: string; update_description?: string }): Promise<UpdateReleaseUploadResp> {
    const res = await Request<typeof query, { data: UpdateReleaseUploadResp }>({
      api: '/api/update/release/upload',
      method: 'POST',
      data: query,
    });
    return res.data;
  },
  async list(query: {
    name?: string;
    build_number?: number | string;
    status?: UpdateReleaseStatus;
    current?: number;
    size?: number;
  }): Promise<UpdatePageResp<UpdateReleaseRecord>> {
    const res = await Request<typeof query, { data: UpdatePageResp<UpdateReleaseRecord> }>({
      api: '/api/update/release/list',
      method: 'GET',
      data: cleanUpdateQuery(query),
    });
    return res.data;
  },
  async detail(id: number): Promise<UpdateReleaseDetailResp> {
    const res = await Request<{ id: number }, { data: UpdateReleaseDetailResp }>({
      api: '/api/update/release/detail',
      method: 'GET',
      data: { id },
    });
    return res.data;
  },
  async update(query: { id: number; name?: string; remark?: string; update_description?: string }): Promise<UpdateReleaseUpdateResp> {
    const res = await Request<typeof query, { data: UpdateReleaseUpdateResp }>({
      api: '/api/update/release/update',
      method: 'POST',
      data: query,
    });
    return res.data;
  },
  async switchStatus(query: { id: number; status: UpdateReleaseStatus; create_rollout_drafts?: boolean }): Promise<UpdateReleaseStatusResp> {
    const res = await Request<typeof query, { data: UpdateReleaseStatusResp }>({
      api: '/api/update/release/status',
      method: 'POST',
      data: query,
    });
    return res.data;
  },
};

export const UpdateModule = {
  async versionList(query: {
    module_key?: string;
    release_statuses?: UpdateReleaseStatus[];
    module_statuses?: UpdateModuleStatus[];
    current?: number;
    size?: number;
  }): Promise<UpdatePageResp<UpdateModuleVersionRecord>> {
    const res = await Request<typeof query, { data: UpdatePageResp<UpdateModuleVersionRecord> }>({
      api: '/api/update/module/version_list',
      method: 'GET',
      data: cleanUpdateQuery(query),
    });
    return res.data;
  },
};

export const UpdateRollout = {
  async upsert(query: {
    id?: number;
    module_version_id: number;
    download_percent?: number;
    use_percent?: number;
    status: UpdateRolloutStatus;
    remark?: string;
  }): Promise<UpdateRolloutUpsertResp> {
    const res = await Request<typeof query, { data: UpdateRolloutUpsertResp }>({
      api: '/api/update/rollout/upsert',
      method: 'POST',
      data: query,
    });
    return res.data;
  },
  async list(query: {
    module_key?: string;
    module_version_id?: number;
    status?: UpdateRolloutStatus;
    rollout_status?: UpdateRolloutStatus;
    rollout_statuses?: UpdateRolloutStatus[];
  }): Promise<{ records: UpdateRolloutRecord[] }> {
    const res = await Request<typeof query, { data: { records: UpdateRolloutRecord[] } }>({
      api: '/api/update/rollout/list',
      method: 'GET',
      data: cleanUpdateQuery(query),
    });
    return res.data;
  },
};

export async function TokenUpdate(token: string) {
  return Request({
    api: '/api/proxy_update_token',
    method: 'POST',
    data: {
      token: token,
    },
  });
}
